export default __webpack_public_path__ + "static/media/es-ce.6f151caa.svg";